export default function getCookie(cookiename) {
    if (document.cookie.length > 0) {
        let startC = document.cookie.indexOf(cookiename + "=");
        if (startC != -1) {
            startC += cookiename.length + 1;
            let endC = document.cookie.indexOf(";", startC);
            if (endC == -1) {
                endC = document.cookie.length;
            }
            return unescape(document.cookie.substring(startC, endC));
        }
    }
    return null;
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sales-force-push/get-cookie.js